export const sluggify = (str = '') => {
  if (str && str.length > 0) {
    return str
      .normalize('NFD') // split an accented letter in the base letter and the acent
      .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-') // remove all chars not letters, numbers and spaces (to be replaced)
      .replace(/^-+|-+$/g, '') // separator
  }
}

export const importModules = async (modules) => {
  for (const key of modules.keys()) {
    const module = await modules(key)
    if (module.default) {
      module.default()
    }
  }
}

export const isInViewport = (element, percentToBeVisible = 25) => {
  const rect = element.getBoundingClientRect()
  const html = document.documentElement
  const viewportHeight = window.innerHeight || html.clientHeight
  const viewportWidth = window.innerWidth || html.clientWidth

  // Calculate visible area
  const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0)
  const visibleWidth = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0)

  // Calculate visible percentage
  const visibleArea = visibleHeight * visibleWidth
  const totalArea = rect.height * rect.width
  const visiblePercentage = (visibleArea / totalArea) * 100

  return visiblePercentage >= percentToBeVisible
}
